import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MAESTRO_IMG } from "../../constants/Constant";
import { YAMMER_URL } from '../../constants/serverConfig'
import { DBK_RELEASE_URL } from "../../constants/Constant";

const Footer = () => {
  // let alphadate = moment("2023-03-31").format("DD - MM - YYYY");

  return (
    <div className="sticky-footer">
      <footer>
        <Container className="w-100">
          <Row>
            <Col xl={6} lg={6} md={6} xs={6} className="text-white text-left">
              {/* <a
              href="/databook/release"
              target="_blank"
              rel="noreferrer"
              className="release"
            >
              Version : Alpha{" "}
              <div className="badge badge-default badge-outlined">
                {alphadate}
              </div>
            </a> */}
              <div className="logo__word">
                <span>
                  V 1.4.0 - Powered by <img src={MAESTRO_IMG} alt="Maestro img" />
                </span>
              </div>
            </Col>
            <Col xl={6} lg={6} md={6} xs={6} className="text-right text-white">
              {/* Made With <span className="heart">&#9825;</span> by
            <span>
              &nbsp;
              <a
                href="mailto:XDMaestroPlatformCapability@maersk.com"
                className="text-white mail"
              >
                <strong>Platform Capability Team</strong>
              </a>
            </span> */}
              <div className="f__links">
                <span>
                  <a
                    href={YAMMER_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Yammer
                  </a>{" "}
                  {/* |{" "}
                  <a
                    href="https://teamsite.maerskgroup.com/teams/maestro/SitePages/Maestro-Core-Engineering.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    TeamSite
                  </a>{" "} */}
                  {/* | FAQ | Documentation | Privacy Policy | Terms of Use */}
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Footer;
